import React, { Suspense } from "react";
import { Layout, Spin } from "antd";

import "./Content.scss";

const { Content } = Layout;

const AppContent = ({ children }) => {
  return (
    <Content>
      <Suspense
        fallback={
          <div className="content__loader">
            <Spin size="large" />
          </div>
        }
      >
        {children}
      </Suspense>
    </Content>
  );
};

export default React.memo(AppContent);
